// extracted by mini-css-extract-plugin
module.exports = {"tableDataContainer":"TableData__tableDataContainer--2zr","accordionContainer":"TableData__accordionContainer--3po"};